export default "__VITE_ASSET__dXCnqsae__"